<p
    [id]="id()"
    [pTooltip]="pTooltip"
    [tooltipPosition]="tooltipPosition()"
    [tooltipStyleClass]="'ellipsis-tooltip-text'"
    [style.-webkit-line-clamp]="ellipsisNumberOfRows()"
    [showDelay]="tooltipDelayTime()"
    [tooltipDisabled]="disableTooltip()"
    [escape]="tooltipEscape()"
    class="ellipsis vertical-ellipsis"
    #contentTemplate
    (mouseenter)="shouldShowTooltip()">
    <ng-content></ng-content>
</p>
